var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredentialHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1132,
    viewBox: "0 0 1512 1132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "CredIssuer verified digital credential hero illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    /* Ambient motion respects users who prefer reduced motion.\n       Orbital motion is driven by SMIL animateMotion below so the\n       tiles ride an elliptical track while staying perfectly upright. */\n    @media (prefers-reduced-motion: no-preference) {\n      .pulse-core { transform-box: fill-box; transform-origin: center; animation: breathe 5s ease-in-out infinite; }\n      .pulse-glow { transform-box: fill-box; transform-origin: center; animation: breatheGlow 5s ease-in-out infinite; }\n      .pulse-hotspot { transform-box: fill-box; transform-origin: center; animation: hotspotPulse 3.6s ease-in-out infinite; }\n      .beam       { animation: shimmer 5s ease-in-out infinite; }\n      .gloss      { animation: sweep 6.5s ease-in-out infinite; }\n      .badge      { transform-box: fill-box; transform-origin: center; animation: pop 4s ease-in-out infinite; }\n      .podium-ring {\n        transform-box: fill-box;\n        transform-origin: center;\n        animation: ringBounce 3.8s cubic-bezier(0.22, 1, 0.36, 1) infinite;\n      }\n      .podium-ring.back  { animation-delay: 0s; }\n      .podium-ring.mid   { animation-delay: 0.12s; }\n      .podium-ring.front { animation-delay: 0.24s; }\n    }\n    @keyframes breathe    { 0%,100% { scale: 1;    opacity: 0.85; } 50% { scale: 1.06; opacity: 1; } }\n    @keyframes breatheGlow{ 0%,100% { scale: 1;    opacity: 0.75; } 50% { scale: 1.10; opacity: 1; } }\n    @keyframes hotspotPulse { 0%,100% { scale: 1; opacity: 0.92; } 50% { scale: 1.14; opacity: 1; } }\n    @keyframes shimmer    { 0%,100% { opacity: 0.4;  } 50% { opacity: 0.72; } }\n    @keyframes pop        { 0%,88%,100% { scale: 1; } 44% { scale: 1.16; } }\n    @keyframes sweep      { 0% { translate: 0; } 15%,100% { translate: 840px; } }\n    @keyframes ringBounce {\n      0%, 100% { transform: translateY(0px) scaleX(1) scaleY(1); }\n      18%      { transform: translateY(-4px) scaleX(1.012) scaleY(0.992); }\n      34%      { transform: translateY(0px) scaleX(0.996) scaleY(1.004); }\n      48%      { transform: translateY(-10px) scaleX(1.02) scaleY(0.985); }\n      62%      { transform: translateY(1px) scaleX(0.994) scaleY(1.006); }\n      78%      { transform: translateY(-3px) scaleX(1.008) scaleY(0.996); }\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: 0.5,
    cy: 0.4,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3A34C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#211F98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100F5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6D5DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2FD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7C6BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plane",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EFEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9AEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tileGrad",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2A2770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tileStroke",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tileHi",
    cx: 0.3,
    cy: 0.16,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8E82FF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E82FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "podium",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9C8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B2FB0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "podiumGlow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B9AEFF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9AEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beam",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E4DEFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "core",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EAE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAE4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "orbA",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6E5CFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E5CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "orbB",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3AA0FF",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AA0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cardShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 34,
    stdDeviation: 40,
    floodColor: "#0A0942",
    floodOpacity: 0.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tileShadow",
    x: "-45%",
    y: "-45%",
    width: "190%",
    height: "190%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 16,
    stdDeviation: 20,
    floodColor: "#070627",
    floodOpacity: 0.55
  })), /*#__PURE__*/React.createElement("filter", {
    id: "iconGlow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1132
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cardClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 352,
    width: 520,
    height: 372,
    rx: 26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFFFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "orbit",
    fill: "none",
    d: "M1376 540 A620 450 0 1 1 136 540 A620 450 0 1 1 1376 540"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rayGrad",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D8D0FF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bloom",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CFC4FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E82FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rayBlur",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "ray",
    d: "M0 0 L-7 -215 L7 -215 Z",
    fill: "url(#rayGrad)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tileFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 34,
    fill: "url(#tileGrad)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 34,
    fill: "url(#tileHi)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 148.5,
    height: 148.5,
    rx: 33.25,
    fill: "none",
    stroke: "url(#tileStroke)",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#orbit",
    stroke: "#C4BEFF",
    strokeOpacity: 0.55,
    strokeWidth: 2,
    strokeDasharray: "2 10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "pulse-glow",
    cx: 756,
    cy: 846,
    rx: 270,
    ry: 96,
    fill: "url(#podiumGlow)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "podium-ring back",
    cx: 756,
    cy: 866,
    rx: 176,
    ry: 34,
    fill: "url(#podium)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "podium-ring mid",
    cx: 756,
    cy: 848,
    rx: 150,
    ry: 29,
    fill: "url(#podium)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "podium-ring front",
    cx: 756,
    cy: 828,
    rx: 126,
    ry: 24,
    fill: "url(#podium)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "beam",
    transform: "translate(756 810)",
    filter: "url(#rayBlur)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(-44) scale(0.8 0.6)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(-34) scale(0.9 0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(-24) scale(0.95 1)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(-15) scale(0.9 0.9)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(-8) scale(1 1.15)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(-3) scale(1.05 1.25)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(3)  scale(1.05 1.25)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(8)  scale(1 1.15)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(15) scale(0.9 0.9)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(24) scale(0.95 1)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(34) scale(0.9 0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#ray",
    transform: "rotate(44) scale(0.8 0.6)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "pulse-core",
    cx: 756,
    cy: 810,
    rx: 130,
    ry: 52,
    fill: "url(#bloom)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 756,
    cy: 808,
    rx: 56,
    ry: 21,
    fill: "url(#core)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "pulse-hotspot",
    cx: 756,
    cy: 806,
    rx: 24,
    ry: 10,
    fill: "#FFFFFF",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(756 538) scale(1.15) translate(-756 -538)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 352,
    width: 520,
    height: 372,
    rx: 26,
    fill: "url(#card)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 370,
    width: 484,
    height: 336,
    rx: 16,
    fill: "none",
    stroke: "#C3C8DE",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 377,
    width: 470,
    height: 322,
    rx: 11,
    fill: "none",
    stroke: "#E1E4F0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 546,
    y: 424,
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 17,
    fontWeight: 700,
    letterSpacing: 2.5,
    fill: "#6B6FA0"
  }, "CERTIFICATE OF"), /*#__PURE__*/React.createElement("text", {
    x: 544,
    y: 463,
    fontFamily: "Georgia,'Times New Roman',serif",
    fontSize: 35,
    fontWeight: 700,
    fill: "#1E1B4B"
  }, "Participation"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(930 434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(2) translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1716 21.2062C24.2776 22.7989 22.9608 24.1792 21.2673 25.1611C16.2321 28.0806 9.78924 26.3497 6.87891 21.2874C6.86138 21.2569 6.84406 21.2264 6.82692 21.1959C6.48868 20.5941 5.72763 20.3822 5.12708 20.7226C4.52653 21.0631 4.3139 21.8269 4.65215 22.4288C4.6733 22.4664 4.69464 22.5039 4.71615 22.5414C8.31214 28.7963 16.2793 30.943 22.5133 27.3285C24.6055 26.1154 26.2384 24.405 27.346 22.4317C27.6844 21.8287 27.472 21.0656 26.8716 20.7272C26.2711 20.3887 25.51 20.6032 25.1716 21.2062ZM21.04 13.0766C22.6491 15.8755 21.6926 19.4501 18.9112 21.0627C18.2923 21.4216 17.6376 21.6524 16.9758 21.765C16.2961 21.8808 15.8375 22.5272 15.9516 23.2089C16.0657 23.8906 16.7092 24.3494 17.389 24.2337C18.3395 24.0719 19.2768 23.7406 20.1572 23.2301C24.1374 20.9224 25.4975 15.8141 23.2028 11.8226C22.6922 10.9345 22.0418 10.1742 21.2947 9.55542C20.7636 9.11561 19.977 9.19161 19.5376 9.72517C19.0982 10.2587 19.1725 11.0478 19.7035 11.4876C20.2247 11.9192 20.6803 12.4508 21.04 13.0766ZM26.5342 16.0899C26.5277 16.7813 27.0811 17.3461 27.7704 17.3513C28.4596 17.3565 29.0236 16.8003 29.0301 16.1088C29.0513 13.8482 28.4888 11.5526 27.2837 9.45641C24.2488 4.1774 18.1036 1.82682 12.5126 3.39096C11.8483 3.57678 11.459 4.26734 11.643 4.93336C11.8271 5.59938 12.5147 5.98865 13.1789 5.80282C17.6965 4.539 22.6665 6.44103 25.121 10.7104C26.0979 12.4096 26.5513 14.264 26.5342 16.0899ZM10.6966 22.4352C11.227 22.8757 12.0138 22.8008 12.4539 22.2678C12.894 21.7349 12.8208 20.9457 12.2903 20.5052C11.7717 20.0745 11.3182 19.5445 10.9599 18.9212C9.3508 16.1223 10.3073 12.5477 13.0887 10.935C13.7035 10.5786 14.3535 10.3485 15.0108 10.235C15.6903 10.1177 16.1473 9.47019 16.0316 8.78876C15.916 8.10732 15.2714 7.65 14.5919 7.7673C13.6479 7.93027 12.7172 8.2606 11.8427 8.76765C7.86254 11.0754 6.50239 16.1836 8.79712 20.1752C9.30571 21.0598 9.95306 21.8177 10.6966 22.4352ZM2.96969 16.121C2.97542 16.8124 3.5388 17.3673 4.22803 17.3602C4.91726 17.3532 5.47134 16.787 5.46561 16.0956C5.44209 13.2584 6.55694 10.4766 8.61789 8.44737C9.11025 7.96259 9.11838 7.1699 8.63605 6.67685C8.15371 6.1838 7.36356 6.17711 6.8712 6.66189C4.31561 9.17813 2.94065 12.6181 2.96969 16.121ZM17.0927 16.1594C17.0927 16.7117 16.645 17.1594 16.0927 17.1594C15.5405 17.1594 15.0927 16.7117 15.0927 16.1594C15.0927 15.6071 15.5405 15.1594 16.0927 15.1594C16.645 15.1594 17.0927 15.6071 17.0927 16.1594ZM19.0927 16.1594C19.0927 17.8162 17.7496 19.1594 16.0927 19.1594C14.4359 19.1594 13.0927 17.8162 13.0927 16.1594C13.0927 14.5025 14.4359 13.1594 16.0927 13.1594C17.7496 13.1594 19.0927 14.5025 19.0927 16.1594Z",
    fill: "#3538CD"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 512,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 3,
    fill: "#9AA0B8"
  }, "PROUDLY PRESENTED TO"), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 558,
    textAnchor: "middle",
    fontFamily: "Georgia,'Times New Roman',serif",
    fontSize: 38,
    fontWeight: 700,
    fill: "#1E1B4B"
  }, "Anuj Jain"), /*#__PURE__*/React.createElement("line", {
    x1: 676,
    y1: 578,
    x2: 836,
    y2: 578,
    stroke: "#C7CBE0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 604,
    textAnchor: "middle",
    fontFamily: "Georgia,'Times New Roman',serif",
    fontSize: 15,
    fontStyle: "italic",
    fill: "#6B7090"
  }, "June 24, 2025"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.8 391.3) scale(0.4559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 858,
    y: 528,
    width: 136,
    height: 136,
    rx: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#12103A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 536,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 540.14,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 544.28,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 548.41,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 552.55,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 556.69,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 560.83,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 564.97,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 564.97,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 564.97,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 564.97,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 564.97,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 569.1,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 573.24,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 577.38,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 581.52,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 585.66,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 589.79,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 593.93,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 598.07,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 602.21,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 606.34,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 610.48,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 894.97,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 614.62,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 618.76,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 622.9,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 627.03,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 631.17,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 635.31,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.24,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.59,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 639.45,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 944.62,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 977.72,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 643.59,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.07,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932.21,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 647.72,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.14,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874.28,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878.41,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 882.55,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.69,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 890.83,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899.1,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.38,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 911.52,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.66,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.79,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.93,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936.34,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 940.48,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 948.76,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 952.9,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.03,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 961.17,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 965.31,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.45,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 981.86,
    y: 651.86,
    width: 4.14,
    height: 4.14
  }))), /*#__PURE__*/React.createElement("text", {
    x: 618,
    y: 670,
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1.5,
    fill: "#9AA0B8"
  }, "VERIFY AT"), /*#__PURE__*/React.createElement("text", {
    x: 618,
    y: 687,
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#4B4780"
  }, "verify.credissuer.com"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(926 676) skewX(-17) translate(-926 -676)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#232A86",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860 688 C 852 672 870 652 882 662 C 891 670 884 686 877 690 C 871 693 881 681 888 683 C 896 685 892 672 900 675 C 907 678 903 689 910 686 C 916 684 914 674 920 672",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914 686 C 921 660 946 658 934 681 C 927 693 944 691 953 683 C 963 674 958 662 967 668 C 974 672 969 687 980 684 C 989 681 986 674 995 678",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#232A86"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 911,
    cy: 665,
    rx: 1.8,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 957,
    cy: 661,
    rx: 1.8,
    ry: 1.8
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 866,
    y1: 700,
    x2: 988,
    y2: 700,
    stroke: "#C7CBE0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 927,
    y: 716,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 14,
    fill: "#6B7090"
  }, "Authorized Signatory")), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cardClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "gloss",
    x: 360,
    y: 320,
    width: 150,
    height: 440,
    fill: "url(#glossGrad)",
    transform: "rotate(14 435 540)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -75)",
    filter: "url(#tileShadow)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tileFrame"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EDEBFF",
    strokeWidth: 3.2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 26 h30 a2 2 0 0 1 2 2 v16 a2 2 0 0 1 -2 2 h-30 a2 2 0 0 1 -2 -2 v-16 a2 2 0 0 1 2 -2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 33 h18 M66 39 h12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 58,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 58 l3 3 l6 -7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 65 L66 78 L72 74 M80 65 L84 78 L78 74"
  })), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 102,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Credential"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 122,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Issued")), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "44s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -75)",
    filter: "url(#tileShadow)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tileFrame"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EDEBFF",
    strokeWidth: 3.2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 32 L92 40 L68 64 L60 66 L62 58 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 37 L87 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 72 h30"
  })), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 102,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Digitally"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 122,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Signed")), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "44s",
    begin: "-7.33s",
    repeatCount: "indefinite",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -75)",
    filter: "url(#tileShadow)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tileFrame"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EDEBFF",
    strokeWidth: 3.2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 27 L95 36 V53 C95 67 86 76 75 82 C64 76 55 67 55 53 V36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 53 L73 60 L86 45"
  })), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 110,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Tamper-Proof")), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "44s",
    begin: "-14.66s",
    repeatCount: "indefinite",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -75)",
    filter: "url(#tileShadow)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tileFrame"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EDEBFF",
    strokeWidth: 3.2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 40 v-6 a4 4 0 0 1 4 -4 h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 40 v-6 a4 4 0 0 0 -4 -4 h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 60 v6 a4 4 0 0 0 4 4 h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 60 v6 a4 4 0 0 1 -4 4 h-6"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EDEBFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.33,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 36,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 37.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 37.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 37.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 37.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 37.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 37.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 38.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 40,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 41.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 42.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 42.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 42.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 42.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 42.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 42.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.33,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 44,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.33,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.33,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 46.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 48,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 48,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 48,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 48,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 48,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 48,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.33,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 49.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.33,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.33,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 50.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.33,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.33,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 52,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 53.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 53.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 53.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 53.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 53.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 53.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.33,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 54.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.33,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 56,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 57.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.33,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 58.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.33,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.33,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.33,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 60,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 61.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 61.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 61.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 61.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 61.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 61.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.67,
    y: 61.33,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.33,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.67,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.33,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.67,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.67,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.67,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.33,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.67,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.67,
    y: 62.67,
    width: 1.33,
    height: 1.33
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 62.67,
    width: 1.33,
    height: 1.33
  })), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 102,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Instant"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 122,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Verification")), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "44s",
    begin: "-22s",
    repeatCount: "indefinite",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -75)",
    filter: "url(#tileShadow)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tileFrame"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EDEBFF",
    strokeWidth: 3.2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 46,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 40 v-3 a3 3 0 0 1 3 -3 h22 a3 3 0 0 1 3 3 v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 51 h-13 a5 5 0 0 0 0 10 h13"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 56,
    r: 2.8,
    fill: "#EDEBFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 102,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Wallet"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 122,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Ready")), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "44s",
    begin: "-29.33s",
    repeatCount: "indefinite",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -75)",
    filter: "url(#tileShadow)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tileFrame"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 50 L96 34 L83 74 L74 58 Z",
    fill: "url(#plane)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 34 L74 58",
    stroke: "#2A2878",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 102,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Instantly"), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 122,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFFFFF"
  }, "Shareable")), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "44s",
    begin: "-36.66s",
    repeatCount: "indefinite",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#orbit"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialHero);
export default __webpack_public_path__ + "static/media/credential-hero.9c33c1736f35c53f6919b1e150e04d4d.svg";
export { ForwardRef as ReactComponent };